import React from 'react';
import { Box, Text } from '@fullstory/components';
import { EngagementMapsDetailsRow } from '../EngagementMapsDetailsRow';
import { FormattedMessage, useIntl } from 'react-intl';

export interface PageViewsRowProps {
  pageViews: number;
}

export const PageViewsRow: React.FC<PageViewsRowProps> = ({ pageViews }) => {
  const intl = useIntl();
  return (
    <EngagementMapsDetailsRow
      data-component="PageViewsRow"
      icon={{ name: 'omnisearch/visited' }}
      label={{ body: intl.formatMessage({ defaultMessage: 'Page Views:', id: 'EO2Jxb' }) }}
      value={{ body: intl.formatNumber(pageViews) }}
      tooltipContent={
        <Box>
          <Text appearance="bodySmall" color="inherit">
            <FormattedMessage
              defaultMessage="An instance of a page being loaded in the browser. A single user could have multiple page views per session."
              id="uuWBIb"
            />
          </Text>
        </Box>
      }
    />
  );
};
